import _ from 'lodash'
import { formatPromotionDate } from './date'
import { EMAIL_EMPTY_DATA_ACCOUNT } from '../constants'
import { logMediumLog } from './logger';

const DEFAULT_ERROR = 'La connexion a été perdue. Veuillez réessayer.';
export const DEFAULT_SEND_ORDER_ERROR = 'Nous rencontrons un problème lors de l\'envoi de votre commande. Veuillez réessayer.';

export const ERROR_MESSAGES = {
  'auth/no-user-data': EMAIL_EMPTY_DATA_ACCOUNT,
  'auth/error-signup':
    'La création de votre compte a échoué. Veuillez vérifier les informations saisies.',
  'auth/invalid-email': 'Votre email est incorrect ! Veuillez réessayer',
  'auth/email-already-in-use':
    'Un compte est déjà associé à cet email \n! Veuillez réessayer',
  'auth/weak-password':
    'Votre mot de passe doit contenir au moins 6 caractères ! Veuillez réessayer',
  'auth/number-phone-empty':
    'Vous devez entrer un numéro de téléphone !\n Veuillez réessayer',
  'auth/email-empty': 'Vous devez entrer un email !\n Veuillez réessayer',
  'auth/password-empty':
    'Vous devez entrer un mot de passe !\n Veuillez réessayer',
  'auth/firstname-empty': 'Vous devez entrer votre prénom ! Veuillez réessayer',
  'auth/lastname-empty':
    'Vous devez entrer votre nom de famille ! Veuillez réessayer',
  'auth/user-disabled':
    'Votre compte a été supprimé ! Veuillez contacter le support pour plus d\'informations',
  'auth/user-not-found':
    'Votre compte n\'existe pas !\n Inscrivez-vous pour ouvrir un compte',
  'auth/wrong-password':
    'Votre mot de passe est incorrect ! Veuillez réessayer',
  'auth/wrong-birth-date':
    'Veuillez rentrer votre date de naissance sous le format jj/mm/aaaa !',
  'auth/facebook_error':
    'Nous n\'avons pas pu vous connecter via Facebook! Veuillez réessayer',
  'auth/facebook_cancel':
    'La connexion via Facebook a été annulée! Veuillez réessayer',
  incorrect_number:
    'Le numéro de votre carte bancaire est incorrect! Veuillez réessayer',
  expired_card: 'Votre carte bancaire a expiré ! Veuillez réessayer',
  invalid_expiry_year: 'Votre carte bancaire est expirée !',
  incorrect_cvc: 'Le numéro CVC est incorrect! Veuillez réessayer',
  card_declined:
    'Votre carte bancaire est incorrecte ou bien ne possède pas les fonds nécessaires pour effectuer votre commande! Veuillez modifier vos informations de carte bancaire ou contacter votre banque pour plus d\'informations.',
  parameter_missing: 'Votre carte bancaire est incorrecte! Veuillez réessayer.',
  resource_missing: 'Votre carte bancaire est manquante! Veuillez réessayer.',
  'auth/agreement-unchecked':
    'Vous devez accepter nos Conditions générales d\'utilisation pour pouvoir continuer.',
  'auth/under-eighteen': 'Vous devez avoir plus de 18 ans.',
  'auth/wrong-number-phone': 'Votre numéro de téléphone est incorrect.',
  'auth/password-not-match':
    'Votre mot de passe doit être identique ! Veuillez réessayer.',
  'auth/too-many-requests':
    'Vous avez effectué trop de tentatives ! Veuillez réessayer plus tard.',
  'address/wrong-address': 'Entrez une adresse de livraison valide.',
  'address/missing-city': 'Votre adresse n\'a pas de ville',
  'address/missing-street': 'Votre adresse n\'a pas de rue',
  'address/missing-street-number': 'Votre adresse n\'a pas de numéro de rue',
  CANT_GEOCODE_ADDRESS: 'Entrez une adresse de livraison valide.',
  OUT_OF_RANGE: 'Entrez une adresse de livraison valide.',
  ADDRESS_CONTACT_PHONE_REQUIRED: 'Votre adresse n\'est pas assez précise.',
  'address/error-address':
    'Nous n\'avons pas pu ajouter votre adresse. Veuillez réessayer.',
  'promotion/promotion-pending': 'Vous avez déjà un code promotionnel en cours',
  'promotion/promotion-expired':
    'Ce code promotionnel n\'existe pas ou a expiré',
  'promotion/loyalty-invalid':
    'Pas assez de points pour obtenir vos points de fidélités',
  'promotion/promotion-already-used':
    'Vous avez déjà utilisé ce code promotionnel.',
  'promotion/canal-not-authorized':
    'Ce code promotionnel n\'est pas autorisé sur cette application.',
  'promotion/ordertype-not-authorized':
    'Ce code promotionnel n\'est pas autorisé pour ce mode de vente.',
  'stuart/phone-invalid':
    'Nous n\'avons pas pu lancer votre livraison car votre numéro de téléphone est invalide.',
  'stuart/unavailable':
    'Notre service de livraison est indisponible pour le moment. Veuillez réessayer plus tard.',
  'stuart/address-not-served':
    'Notre service de livraison ne dessert pas votre adresse.',
  'stuart/job-already-pickedup':
    'Veuillez contacter le livreur pour pouvoir annuler votre commande.',
  'auth/error-updateInfo':
    'La modification de votre compte a échoué. Veuillez vérifier les informations saisies.',
  'orders/limit':
    'Le nombre maximum de commandes pour ce créneau a été atteint. Veuillez choisir un créneau différent',
};

const parseDefaultError = (error) => error || DEFAULT_ERROR;

export const renderErrorMessage = (error, param = null) => {
  if (error.startsWith('promotion/')) {
    switch (error) {
      case 'promotion/promotion-available-later/startedDate': {
        const date = formatPromotionDate(param?.startedDate);
        return `Soyez patient ce code promotionnel sera disponible à partir du ${date}`;
      }
      case 'promotion/promotion-expired/endedDate': {
        const date = formatPromotionDate(param?.endedDate);
        return `Malheureusement ce code promotionnel n'est plus disponible depuis le ${date}`;
      }
      default:
        return ERROR_MESSAGES[error] || parseDefaultError(error);
    }
  }
  logMediumLog(`Default error message: ${JSON.stringify(error)}`);
  return ERROR_MESSAGES[error] || parseDefaultError(error);
};

export const handleJoiSchemaError = (error) =>
  Array.isArray(error) ? _.map(error, (e) => e.message) : error;

export const ADDRESS_MISSING_CITY = 'Votre adresse n\'a pas de ville';
export const ADDRESS_MISSING_STREET = 'Votre adresse n\'a pas de rue';
export const ADDRESS_MISSING_STREET_NUMBER =
  'Votre adresse n\'a pas de numéro de rue';
